var _circle, _g, _circle2, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeAtividadeColetiva = function SvgIconeAtividadeColetiva(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_14652_32173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#9BE1D8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14652_32173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 26,
    height: 26
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 12.8,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14652_32173)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_32173)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49667 14.4866C7.49667 14.4866 5.86744 14.3539 5.23807 15.2451C3.57659 17.5978 0.564044 15.3697 -0.0795764 12.9993C-0.63309 10.9608 -0.319675 10.885 -0.390928 10.7712C-0.598567 10.4394 -0.909846 11.0556 -0.909846 11.0556C-0.909846 11.0556 -1.11548 9.82717 -1.49794 10.1548C-2.05136 10.6289 -1.83107 11.8088 -1.77468 12.0986C-1.63633 12.8096 -1.35957 12.7622 -0.702277 14.7533C-0.497362 15.3741 0.370156 17.3133 2.48043 18.5459C3.7211 19.2706 5.80155 19.8436 5.80155 19.8436L6.35503 24.537L10.7486 24.5369L11.2329 19.5111C14.0005 19.6534 16.8609 18.3183 18.0826 14.8652C18.6362 13.3008 18.9821 13.0637 19.0859 12.5422C19.3162 11.3852 19.0167 10.5882 18.7054 10.5511C18.4641 10.5224 18.3248 11.2622 18.221 11.4993C18.1172 11.4045 17.9789 10.9304 17.7367 11.1674C17.5932 11.3079 17.9789 11.2622 17.3216 13.5378C16.6369 15.9082 13.9406 18.0158 11.06 15.2451C10.4246 14.634 9.50316 14.4866 9.50316 14.4866L7.49667 14.4866Z",
    fill: "#36A094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8276 24.5558C10.8276 24.5558 8.57898 24.8402 6.26114 24.5558C5.84601 22.8965 5.1541 20.5555 5.1541 20.5555C5.1541 20.5555 -0.173466 19.3229 -1.2113 13.6815L-0.0696821 12.4489C1.14113 14.5054 3.38097 16.3623 5.1541 15.1217C6.39948 14.2504 7.50653 14.44 7.50653 14.44C7.50653 14.44 8.05924 15.1324 8.61357 15.1217C9.15008 15.1113 9.58221 14.4874 9.58221 14.4874C12.0038 14.4874 13.5952 18.0131 17.2276 13.462C17.7119 13.8412 18.4384 14.3153 18.4384 14.3153C17.02 18.6768 14.1833 20.1464 11.6925 20.1464C11.4849 20.9998 11.1549 23.8411 10.8276 24.5558Z",
    fill: "#02786D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0469 23.1226L4.7821 23.1226C-2.1715 39.5465 1.51287 58.1241 1.51287 58.1241L2.91397 58.1241C2.91397 58.1241 4.37672 43.9843 6.65022 37.1595C6.65022 45.9295 14.7456 54.7511 14.7456 54.7511L15.939 53.9727C8.10332 37.8341 15.3683 31.1401 11.0469 23.1226Z",
    fill: "#997659"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2372 22.9733H4.33547C1.11813 28.3702 -0.438644 43.7822 -2.25488 48.8158L7.5528 48.8158L8.01984 45.8579L9.16152 48.8158H15.2848C13.1053 40.9441 14.177 26.0381 11.2372 22.9733Z",
    fill: "#00443D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0621 11.9106C10.949 12.6676 10.6309 13.2294 10.1266 13.6328C9.71145 13.9649 9.18451 13.9234 9.06534 14.1725C8.94617 14.4216 9.24724 14.7744 9.24724 14.7744C9.24724 14.7744 8.64239 15.5528 7.76023 15.5528C6.87807 15.5528 6.0478 14.7744 6.0478 14.7744C6.43003 14.0479 6.43003 12.534 6.43003 12.534C6.31222 12.3897 6.22084 12.2756 6.22084 12.2756C6.22084 12.2756 5.90048 11.8646 5.78528 11.4524C5.67007 11.0403 5.74882 10.5411 5.80654 10.2795C5.87581 9.96564 6.01965 9.65056 6.22084 9.39153C6.42464 9.12913 6.67839 8.88417 7.18471 8.6668C8.19086 8.23486 8.97888 8.54069 9.24724 8.6668C9.5156 8.79291 9.77524 8.97935 10.0243 9.2561C10.2733 9.53285 11.2266 10.8098 11.0621 11.9106Z",
    fill: "#36A094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7714 9.28903C9.85969 9.16728 9.86898 9.00561 9.77248 8.89026C9.5153 8.58282 8.89138 8.02847 7.73608 8.02847C7.05374 8.02847 6.41484 8.2363 5.95783 8.60789C5.50082 8.97948 5.37971 9.43447 4.89331 10.3059C4.50151 11.0078 2.93525 10.7744 2.82841 11.8943C2.72158 13.0142 3.90665 13.4084 3.90665 13.4084C3.90665 13.4084 4.22543 14.3217 5.01359 14.3217C5.80176 14.3217 6.15122 14.0247 6.15122 14.0247C6.15122 14.0247 7.28288 14.299 7.78903 13.8384C8.29518 13.3777 7.73608 11.76 7.73608 11.76C7.73608 11.76 8.45362 11.1059 8.89414 10.4986C9.19891 10.0785 9.57101 9.56537 9.7714 9.28903Z",
    fill: "#00443D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_14652_32173)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7035 15.3236C29.7035 15.3236 31.4808 15.1811 32.1674 16.1384C34.165 18.9237 36.5735 25.1384 38.0818 28.7677C38.5315 29.8498 39.0293 30.4232 39.2517 30.9569C39.5914 31.7717 39.5914 32.943 39.0631 33.1467C38.8743 33.2195 38.4969 32.5356 38.4215 32.2809C38.3082 32.5865 38.1573 32.892 37.9686 32.7393C37.8553 32.6476 38.0818 32.5865 37.5534 31.2624C36.5815 28.827 31.5527 21.0781 31.5527 21.0781L30.9489 26.1197L26.1559 26.1197L25.6275 20.721C22.6083 20.8738 19.4877 19.4396 18.1549 15.7304C17.5511 14.0499 17.1737 13.7952 17.0604 13.2351C16.8092 11.9922 17.1359 11.1361 17.4756 11.0962C17.7388 11.0654 17.8907 11.8601 18.0039 12.1147C18.1172 12.0129 18.2681 11.5036 18.5323 11.7583C18.6889 11.9092 18.2681 11.8601 18.9852 14.3045C19.7321 16.8507 22.6736 19.1147 25.8162 16.1384C26.5093 15.482 27.5145 15.3236 27.5145 15.3236L29.7035 15.3236Z",
    fill: "#36A094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0794 26.2382C26.0794 26.2382 28.9924 26.5721 31.9951 26.2382C33.2062 21.8518 32.1014 15.7079 30.3817 14.44C30.3817 14.44 29.6657 15.176 28.9476 15.1635C28.2526 15.1513 27.6479 14.6069 27.6479 14.6069C25.4238 16.4313 25.379 23.3322 26.0794 26.2382Z",
    fill: "#9BE1D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7448 15.5899C22.983 16.5176 21.2205 17.4456 18.9852 13.4256L17.7703 14.5673C18.6288 19.4811 21.6738 20.6067 23.4653 21.2689C24.2091 21.5439 24.7368 21.739 24.8022 22.0921C25.0195 23.2663 22.4323 39.6445 22.4323 39.6445H26.5557L27.4393 15.9802L27.0711 14.7866C26.2703 14.7866 25.5076 15.1882 24.7448 15.5899ZM34.0419 39.385H28.7267C28.6377 36.7621 28.3217 15.9283 28.3217 15.9283L29.2789 14.7866C29.2789 14.7866 31.015 14.6083 31.9297 15.6688C34.2123 18.3155 36.8399 24.3755 38.2758 29.4093L36.5822 30.6029C35.8095 29.4477 34.2505 26.3737 33.2179 24.3376C32.6268 23.1722 32.2082 22.3469 32.2082 22.4159C32.2082 26.1816 33.1223 32.7592 33.7944 37.5961C33.8819 38.2252 33.9652 38.8248 34.0419 39.385Z",
    fill: "#DBF6F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9375 11.9108C25.0506 12.6679 25.3688 13.2297 25.8731 13.6332C26.2883 13.9653 26.8153 13.9238 26.9344 14.1729C27.0536 14.422 26.7525 14.7749 26.7525 14.7749C26.7525 14.7749 27.3574 15.5533 28.2396 15.5533C29.1218 15.5533 29.9522 14.7749 29.9522 14.7749C29.5699 14.0483 29.5699 12.5343 29.5699 12.5343C29.6877 12.3899 29.7791 12.2758 29.7791 12.2758C29.7791 12.2758 30.0995 11.8648 30.2147 11.4526C30.3299 11.0404 30.2512 10.5412 30.1934 10.2797C30.1242 9.96575 29.9803 9.65065 29.7791 9.39159C29.5753 9.12917 29.3215 8.8842 28.8152 8.66682C27.809 8.23484 27.0209 8.5407 26.7525 8.66682C26.4841 8.79294 26.2245 8.97938 25.9754 9.25615C25.7264 9.53292 24.7731 10.8099 24.9375 11.9108Z",
    fill: "#36A094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6291 9.39377C26.8788 9.47978 26.4995 10.1432 26.7589 10.5844C27.0182 11.0256 27.8609 11.7691 27.8609 11.7691C27.8609 11.7691 28.1713 13.48 28.5562 13.9665C29.2937 14.8985 30.0742 14.5991 30.635 14.8985C31.0705 15.1311 32.1925 16.1115 32.9958 16.2657C33.7992 16.4199 34.9532 16.1115 35.3464 15.291C35.7396 14.4705 35.7202 13.6982 35.0235 12.9145C34.3267 12.1309 33.4544 12.6756 33.0828 12.4046C32.7111 12.1337 32.7841 11.3712 32.1595 10.8147C31.4973 10.2247 30.635 10.0629 30.635 10.0629C30.635 10.0629 30.3259 9.01826 29.4114 8.49783C28.4968 7.9774 27.5205 8.04674 26.8347 8.29637C25.8699 8.64758 25.6662 9.58724 25.7684 9.59797C25.8705 9.60871 26.3793 9.30776 26.6291 9.39377Z",
    fill: "#00443D"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3499 15.2533V17.7205C30.3499 18.8983 29.4784 19.909 28.3045 20.0722C28.2807 20.9834 28.6602 24.0076 25.7738 24.0076C25.4341 24.0076 25.0978 23.9407 24.784 23.8107C24.4701 23.6808 24.185 23.4902 23.9448 23.2501C23.7047 23.0099 23.5141 22.7248 23.3842 22.411C23.2542 22.0971 23.1873 21.7608 23.1873 21.4211V20.9078C22.7257 20.7407 22.3914 20.303 22.3914 19.7897C22.3914 19.4731 22.5172 19.1694 22.7411 18.9455C22.9649 18.7217 23.2686 18.5959 23.5852 18.5959C23.9018 18.5959 24.2054 18.7217 24.4293 18.9455C24.6532 19.1694 24.779 19.4731 24.779 19.7897C24.779 20.303 24.4447 20.7447 23.9831 20.9078V21.3853C23.9831 22.3801 24.779 23.176 25.7738 23.176C27.7132 23.176 27.4769 20.8107 27.4769 20.0682C26.3706 19.8295 25.5748 18.8347 25.5748 17.7205V14.7759C25.5748 14.2454 25.8402 13.98 26.3706 13.98C27.3257 13.98 27.034 14.7759 26.7686 14.7759H26.3706V17.7205C26.3706 18.1426 26.5383 18.5475 26.8368 18.846C27.1353 19.1445 27.5402 19.3122 27.9623 19.3122C28.3845 19.3122 28.7893 19.1445 29.0878 18.846C29.3863 18.5475 29.554 18.1426 29.554 17.7205V14.935L29.7132 14.7758L30.3499 15.2533Z",
    fill: "#02786D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_32173",
    x: 0.333333,
    y: 0.166667,
    width: 35.3333,
    height: 35.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.833333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.733333 0 0 0 0 0.686275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_32173",
    x: -3.4242,
    y: 5.86398,
    width: 24.4915,
    height: 57.1319,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.448
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.627451 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_14652_32173",
    x: 14.5444,
    y: 6.71734,
    width: 27.392,
    height: 56.2822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.448
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.627451 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32173",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeAtividadeColetiva, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-atividade-coletiva.995d2407.svg";
export { ForwardRef as ReactComponent };